import {
  vs2ngaVersionListConstants,
  vs2ngaVersionUploadConstants,
  vs2ngaVersionDeleteConstants,
  vs2ngaVersionConstants,
} from "../_redux-constants";
import { vs2ngaVersionListService } from "../../_services";

function getVs2ngaVersionList(queryParams) {
  function getVs2ngaVersionListLoad() {
    return { type: vs2ngaVersionListConstants.VS2NGAVERSION_LIST_LOADING };
  }
  function vs2ngaVersionListSuccess(data) {
    return {
      type: vs2ngaVersionListConstants.VS2NGAVERSION_LIST_SUCCESS,
      data,
    };
  }
  function vs2ngaVersionListFailure(error) {
    return {
      type: vs2ngaVersionListConstants.VS2NGAVERSION_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getVs2ngaVersionListLoad());
    return vs2ngaVersionListService.getVs2ngaVersionList(queryParams).then(
      (data) => {
        dispatch(vs2ngaVersionListSuccess(data));
      },
      (error) => {
        dispatch(vs2ngaVersionListFailure(error?.toString()));
      }
    );
  };
}

function uploadVs2ngaVersion(queryParams) {
  function vs2ngaVersionUploadLoad() {
    return { type: vs2ngaVersionUploadConstants.VS2NGAVERSION_UPLOAD_LOADING };
  }
  function vs2ngaVersionUploadSuccess(data) {
    return {
      type: vs2ngaVersionUploadConstants.VS2NGAVERSION_UPLOAD_SUCCESS,
      data,
    };
  }
  function vs2ngaVersionUploadFailure(error) {
    return {
      type: vs2ngaVersionUploadConstants.VS2NGAVERSION_UPLOAD_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(vs2ngaVersionUploadLoad());
    return new Promise((resolve, reject) => {
      vs2ngaVersionListService.uploadVs2ngaVersion(queryParams).then(
        (data) => {
          dispatch(vs2ngaVersionUploadSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(vs2ngaVersionUploadFailure(error));
          reject(error);
        }
      );
    });
  };
}

function deleteVs2ngaVersion(queryParams) {
  function vs2ngaVersionDeleteLoad() {
    return { type: vs2ngaVersionDeleteConstants.VS2NGAVERSION_DELETE_LOADING };
  }
  function vs2ngaVersionDeleteSuccess(data) {
    return {
      type: vs2ngaVersionDeleteConstants.VS2NGAVERSION_DELETE_SUCCESS,
      data,
    };
  }
  function vs2ngaVersionDeleteFailure(error) {
    return {
      type: vs2ngaVersionDeleteConstants.VS2NGAVERSION_DELETE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(vs2ngaVersionDeleteLoad());
    return vs2ngaVersionListService.deleteVs2ngaVersion(queryParams).then(
      (data) => {
        dispatch(vs2ngaVersionDeleteSuccess(data));
      },
      (error) => {
        dispatch(vs2ngaVersionDeleteFailure(error?.toString()));
      }
    );
  };
}

function vs2ngaVersion(queryParams) {
  function vs2ngaVersionLoad() {
    return { type: vs2ngaVersionConstants.VS2NGAVERSION_LOADING };
  }
  function vs2ngaVersionSuccess(data) {
    return { type: vs2ngaVersionConstants.VS2NGAVERSION_SUCCESS, data };
  }
  function vs2ngaVersionFailure(error) {
    return { type: vs2ngaVersionConstants.VS2NGAVERSION_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(vs2ngaVersionLoad());
    return vs2ngaVersionListService.showVs2ngaVersion(queryParams).then(
      (data) => {
        dispatch(vs2ngaVersionSuccess(data));
      },
      (error) => {
        dispatch(vs2ngaVersionFailure(error?.toString()));
      }
    );
  };
}

export const vs2ngaVersionListActions = {
  getVs2ngaVersionList,
  uploadVs2ngaVersion,
  deleteVs2ngaVersion,
  vs2ngaVersion,
};
